
















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import CircularCountdown from "../Widgets/CircularCountdown/CircularCountdown.vue";
import EventApi from "../../api/EventsApi";
// @ts-ignore
import store from "../../store";
import { GameState } from '../../../types/game-state';

@Component({
    components: {CircularCountdown},
    props: {
        playerLeft: {
            type: Boolean,
            required: true,
        }
    },
})

export default class RestartWithNewPlayerModal extends Vue {
    /**
     * Стейт игры
     * @private
     */
    private get gameState(): GameState.TState
    {
        return store.getters.getGameState;
    }

    private close(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('close');
    }

    private restart(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        const data = {
            contentPackId: this.gameState.tasks.state.content_pack_id,
            setId: 1,
            activityId: this.gameState.tasks.state.activity_id,
            playAgain: true,
        };
        this.$emit('restart', 'getContentPackTasks', data);
        this.$emit('close');
    }
}
